import api from './api';

const CODE_KEYS = ['COD', 'CODIGO', 'codigo', 'cod', 'ID', 'id', 'REF', 'INT'];
const DESC_KEYS = ['DESCRICAO', 'descricao', 'TEXTO', 'texto', 'NOME', 'nome', 'FRASE', 'frase'];

function getFirstObject(value) {
  if (!value) return null;
  if (Array.isArray(value)) return value[0] || null;
  if (typeof value === 'object') return value;
  return null;
}

function getCodeFromObject(obj, fallbackCode) {
  if (!obj) return fallbackCode;
  const foundKey = CODE_KEYS.find((key) => obj[key] !== undefined && obj[key] !== null);
  if (!foundKey) return fallbackCode;
  return String(obj[foundKey]).trim();
}

function getDescriptionFromObject(obj) {
  if (!obj) return '';

  const foundKey = DESC_KEYS.find(
    (key) => obj[key] !== undefined && obj[key] !== null && String(obj[key]).trim() !== ''
  );
  if (foundKey) return String(obj[foundKey]).trim();

  const firstTextLike = Object.entries(obj).find(([key, value]) => {
    if (CODE_KEYS.includes(key)) return false;
    return typeof value === 'string' && value.trim() !== '';
  });

  return firstTextLike ? firstTextLike[1].trim() : '';
}

function normalizeDictionaryEntry(payload, requestedCode) {
  if (!payload) return null;

  if (typeof payload === 'string') {
    return {
      codigo: String(requestedCode || '').trim(),
      descricao: payload.trim(),
      raw: payload,
    };
  }

  const directObject = getFirstObject(payload);
  const fromData = getFirstObject(payload?.data);
  const fromItem = getFirstObject(payload?.item);
  const fromItems = getFirstObject(payload?.items);
  const fromResult = getFirstObject(payload?.result);
  const fromResultados = getFirstObject(payload?.resultados);
  const candidate =
    directObject || fromData || fromItem || fromItems || fromResult || fromResultados;

  if (!candidate) return null;

  const codigo = getCodeFromObject(candidate, String(requestedCode || '').trim());
  const descricao = getDescriptionFromObject(candidate);
  if (!descricao) return null;

  return {
    codigo,
    descricao,
    raw: candidate,
  };
}

export const selectErgoById = async (payload) => {
  const response = await api.get(`ergo/${payload}`);
  return response.data;
};

export const updateErgo = async (id, data) => {
  const response = await api.put(`ergo/${id}`, data);
  return response.data;
};

export const resolveErgoDictionaryItem = async ({ grupo, codigo }) => {
  const trimmedCode = String(codigo || '').trim();
  const trimmedGroup = String(grupo || '').trim();
  if (!trimmedCode || !trimmedGroup) return null;

  const attempts = [
    {
      url: `ergo/dicionario/${encodeURIComponent(trimmedGroup)}/${encodeURIComponent(trimmedCode)}`,
    },
    {
      url: 'ergo/dicionario',
      params: { grupo: trimmedGroup, codigo: trimmedCode },
    },
  ];

  let lastError = null;

  for (const attempt of attempts) {
    try {
      const response = await api.get(
        attempt.url,
        attempt.params ? { params: attempt.params } : undefined
      );
      const normalized = normalizeDictionaryEntry(response?.data, trimmedCode);
      if (normalized) return normalized;
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError?.response?.status && lastError.response.status < 500) {
    return null;
  }

  if (lastError) throw lastError;
  return null;
};

export const listErgoDictionaryItems = async ({ grupo }) => {
  const trimmedGroup = String(grupo || '').trim();
  if (!trimmedGroup) return [];

  const attempts = [
    {
      url: `ergo/dicionarios/${encodeURIComponent(trimmedGroup)}`,
    },
    {
      url: 'ergo/dicionarios',
      params: { grupo: trimmedGroup },
    },
  ];

  let lastError = null;

  for (const attempt of attempts) {
    try {
      const response = await api.get(
        attempt.url,
        attempt.params ? { params: attempt.params } : undefined
      );
      const payload = response?.data;
      const items = Array.isArray(payload?.items)
        ? payload.items
        : Array.isArray(payload)
          ? payload
          : [];

      return items.map((item) => ({
        codigo: item?.CODIGO != null ? String(item.CODIGO).trim() : '',
        descricao: item?.DESCRICAO != null ? String(item.DESCRICAO).trim() : '',
      }));
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError?.response?.status && lastError.response.status < 500) {
    return [];
  }

  if (lastError) throw lastError;
  return [];
};

export const upsertErgoDictionaryItem = async ({ grupo, codigo, descricao }) => {
  const response = await api.post('ergo/dicionario', {
    grupo,
    codigo,
    descricao,
  });
  return response?.data;
};
